import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, NavDropdown, Row } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import { FiChevronDown } from "react-icons/fi";
import { GoChevronRight } from "react-icons/go";

const Header = ({ mode }) => {
  const navigate = useNavigate();
  const [scroll, setScroll] = useState(false);
  const [service, setService] = useState(false);
  const [industry, setIndustry] = useState(false);
  const [about, setAbout] = useState(false);
  // const [mode, setMode] = useState(false);
  useEffect(() => {
    const checkNavbar = () => {
      if (window.scrollY > 60) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    };

    window.addEventListener("scroll", checkNavbar);
    return () => window.removeEventListener("scroll", checkNavbar);
  }, []);

  const servicesMenu = [

{
      icon: "/images/talent-menu-icon.svg",
      title: "Talent Enablement",
      link: "/services/talent",
      description: "Volto connects businesses with skilled, dynamic talent.",
    },
 {
      icon: "/images/Gcc-setup.svg",
      title: "GCC Setup",
      link: "/services/gcc-setup",
      description: " We build and grow Global Capability Centers (GCCs)",
    },
    {
      icon: "/images/executive-search.svg",
      title: "Executive Search",
      link: "/services/executive-search",
      description: "Securing top leadership talent for growth.",
    },
{
      icon: "/images/learning-menu-icon.svg",
      title: "Corporate Training",
      link: "/services/training",
      description: "Empowering Learning and Growth",
    },
 {
      icon: "/images/nearshore-menu-icon.svg",
      title: "Nearshore Services",
      link: "/services/nearshore",
      description: "Nearshore outsourcing enables seamless, skilled teams.",
    },
    {
      icon: "/images/sap-menu-icon.svg",
      title: "SAP Services",
      link: "/services/sap-services",
      description: "SAP TM & S/4HANA experts aligning tech with your goals.",
    },

    {
      icon: "/images/digital-engineering1.svg",
      title: "Digital Engineering",
      link: "/services/digital-engineering",
      description:
        "We ensure scalable, secure, real-time data for informed decisions.",
    },
    {
      icon: "/images/ai-menu-icon.svg",
      title: "AI & Engineering",
      link: "/services/ai-engineering",
      description:
        "Bringing automation to life for you to bring out your best.",
    },
    {
      icon: "/images/data-engineering-menu-icon.svg",
      title: "Data Engineering",
      link: "/services/data-engineering",
      description: "Enhance efficiency and uncover growth opportunities.",
    },
    
    {
      icon: "/images/infura-menu-icon.svg",
      title: "Infrastructure Support",
      link: "/services/infrastructure-support",
      description: "Optimizing operations, reducing costs efficiently.",
    },
   
    
    {
      icon: "/images/cloud-menu-icon.svg",
      title: "Cloud Consulting",
      link: "/services/cloud-consulting",
      description: "We guide your business from evaluation to decision.",
    },
    
   
  ];

  const industryMenu = [
    {
      icon: "/images/digital-engineering1.svg",
      title: "Banking & Finance",
      link: "/industries/banking-and-finance",
      description:
        "We ensure scalable, secure, real-time data for informed decisions.",
    },
    {
      icon: "/images/ai-menu-icon.svg",
      title: "Life Sciences",
      link: "/industries/life-science",
      description:
        "Bringing automation to life for you to bring out your best.",
    },
    {
      icon: "/images/data-engineering-menu-icon.svg",
      title: "Manufacturing",
      link: "/industries/manufacturing",
      description: "Enhance efficiency and uncover growth opportunities.",
    },
    {
      icon: "/images/nearshore-menu-icon.svg",
      title: "Hi-Tech",
      link: "/industries/hi-tech",
      description: "Nearshore outsourcing enables seamless, skilled teams.",
    },
    {
      icon: "/images/sap-menu-icon.svg",
      title: "Travel & Hospitality",
      link: "/industries/travel-and-hospitality",
      description: "SAP TM & S/4HANA experts aligning tech with your goals.",
    },
    {
      icon: "/images/cloud-menu-icon.svg",
      title: "Health Care",
      link: "/industries/healthcare",
      description: "Optimizing operations, reducing costs efficiently.",
    },
    {
      icon: "/images/talent-menu-icon.svg",
      title: "Energy & Utilities",
      link: "/industries/energy-utilities",
      description: "Volto connects businesses with skilled, dynamic talent.",
    },
  ];

  const aboutMenu = [
    {
      icon: "/images/about-menu.svg",
      title: "About Us",
      link: "/about",
      description: "Volto connects businesses with skilled, dynamic talent.",
    },
    {
      icon: "/images/csr-menu.svg",
      title: "CSR",
      link: "/corp-social-responsibility",
      description: "Volto connects businesses with skilled, dynamic talent.",
    },
  ];

  const [navtheme, seNavtheme] = useState(false);

  const toggleTheme = () => {
    seNavtheme((prev) => !prev);
  };

  return (
    <>
      <Navbar
        fixed="top"
        expand="lg"
        className={`volto-navbar desktop-bar z-9 ${scroll ? "change-bg" : ""} ${
          mode === "light" ? "light-mode" : "dark-mode"
        } `}
      >
        <Container style={{ position: "relative" }}>
          <Navbar.Brand>
            <Link to="/">
              <img
                height={32}
                width={133}
                src={
                  scroll || mode === "light" || window.innerWidth < 991
                    ? "/images/volto-clr-logo.svg"
                    : "/images/volto-white-logo.svg"
                }
                alt="Volto Logo"
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="w-100 ms-lg-5 my-lg-6 w-full d-flex items-center justify-content-between align-items-center mobile-alignment"
              navbarScroll
            >
              <div className="d-flex flex-column flex-lg-row">
                <div
                  className="custom-dropdown "
                  onMouseEnter={() =>
                    window.innerWidth >= 991 && setAbout(true)
                  }
                  onMouseLeave={() =>
                    window.innerWidth >= 991 && setAbout(false)
                  }
                  onClick={(e) => {
                    if (window.innerWidth < 991) {
                      setAbout((prev) => !prev);
                      setService(false);
                      setIndustry(false);
                    }
                  }}
                >
                  <NavDropdown
                    title="Who We Are"
                    id="navbarScrollingDropdown"
                  ></NavDropdown>
                  <FiChevronDown
                    className={`chevron-icon d-block ${about ? "rotate" : ""}`}
                  />
                </div>

                <div
                  className="custom-dropdown"
                  onMouseEnter={() =>
                    window.innerWidth >= 991 && setService(true)
                  }
                  onMouseLeave={() =>
                    window.innerWidth >= 991 && setService(false)
                  }
                  onClick={(e) => {
                    if (window.innerWidth < 991) {
                      setService((prev) => !prev);
                      setAbout(false);
                      setIndustry(false);
                    }
                  }}
                >
                  <NavDropdown
                    title="What We Do"
                    id="navbarScrollingDropdown"
                  ></NavDropdown>
                  <FiChevronDown
                    className={`chevron-icon d-block ${
                      service ? "rotate" : ""
                    }`}
                  />
                </div>

                <div
                  className="custom-dropdown"
                  onMouseEnter={() =>
                    window.innerWidth >= 991 && setIndustry(true)
                  }
                  onMouseLeave={() =>
                    window.innerWidth >= 991 && setIndustry(false)
                  }
                  onClick={(e) => {
                    if (window.innerWidth < 991) {
                      setIndustry((prev) => !prev);
                      setService(false);
                      setAbout(false);
                    }
                  }}
                >
                  <NavDropdown
                    title="Industries"
                    id="navbarScrollingDropdown"
                  ></NavDropdown>
                  <FiChevronDown
                    className={`chevron-icon d-block ${
                      industry ? "rotate" : ""
                    }`}
                  />
                </div>

                <Link className="main-link" to="/career">
                  Careers
                </Link>
              </div>

              <CustomButton
                buttonText="Contact Us"
                buttonType="navBtn"
                arrow
                onClick={() => navigate("/contact")}
              />
            </Nav>
          </Navbar.Collapse>

          {window.innerWidth > 991 && (
            <>
            
              {service && (
                <div
                  className="mega-menu "
                  onMouseEnter={() => setService(true)}
                  onMouseLeave={() => setService(false)}
                >
                  <Row className="mobile-menu-row">
                    <Col xs={9}>
                      <Row>
                        {servicesMenu.map((c, i) => (
                          <Col xs={4} key={i}>
                            <Link to={c.link}>
                              <div className="mega-menu-link-bg">
                                <div className="mega-menu-link-container">
                                  <img src={c.icon} alt="icons" />
                                  <Link to={c.link}>{c.title}</Link>
                                  <p>{c.description}</p>
                                </div>
                                <img
                                  className="img-fluid bg-hover"
                                  src="/images/menu-link-ng.svg"
                                  alt="menu-link-bg"
                                />
                              </div>
                            </Link>
                          </Col>
                        ))}
                      </Row>
                    </Col>
                    <Col xs={3} className="">
                      <div className="schedule">
                        <img
                          className="img-fluid"
                          src="/images/schedule.svg"
                          alt="schedule-call"
                        />
                        <CustomButton
                          buttonText="Schedule a Call"
                          buttonType="navBtn"
                          arrow
                          onClick={() => navigate("/contact")}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              )}

              {industry && (
                <div
                  className="mega-menu "
                  onMouseEnter={() => setIndustry(true)}
                  onMouseLeave={() => setIndustry(false)}
                >
                  <Row>
                    <Col xs={12}>
                      <Row>
                        {industryMenu.map((c, i) => (
                          <Col xs={3} key={i}>
                            <Link to={c.link}>
                              <div className="mega-menu-link-bg">
                                <div className="mega-menu-link-container">
                                  <img src={c.icon} alt="icons" />
                                  <Link to={c.link}>{c.title}</Link>
                                  <p>{c.description}</p>
                                </div>
                                <img
                                  className="img-fluid bg-hover"
                                  src="/images/menu-link-ng.svg"
                                  alt="menu-link-bg"
                                />
                              </div>
                            </Link>
                          </Col>
                        ))}
                      </Row>
                    </Col>
                  </Row>
                </div>
              )}

              {about && (
                <div
                  className="mega-menu about-menu"
                  onMouseEnter={() => setAbout(true)}
                  onMouseLeave={() => setAbout(false)}
                >
                  <Row>
                    <Col xs={12}>
                      <Row>
                        {aboutMenu.map((c, i) => (
                          <Col xs={12} key={i}>
                            <Link to={c.link}>
                              <div className="mega-menu-link-bg">
                                <div className="mega-menu-link-container">
                                  <img src={c.icon} alt="icons" />
                                  <Link to={c.link}>{c.title}</Link>
                                  <p>{c.description}</p>
                                </div>
                                <img
                                  className="img-fluid bg-hover"
                                  src="/images/menu-link-ng.svg"
                                  alt="menu-link-bg"
                                />
                              </div>
                            </Link>
                          </Col>
                        ))}
                      </Row>
                    </Col>
                  </Row>
                </div>
              )}
            </>
          )}
        </Container>
      </Navbar>

      <div
        className={`mobile_bar ${
          scroll || mode === "light" ? "bg-white" : ""
        } `}
      >
        <div className="logo">
          <Link to="/">
            <img
              height={32}
              width={133}
              src={
                scroll || mode === "light" || window.innerWidth < 991
                  ? "/images/volto-clr-logo.svg"
                  : "/images/volto-white-logo.svg"
              }
              alt="Volto Logo"
            />
          </Link>
        </div>
        <div
          className={`custom-hamburger ${navtheme ? "ham-animation" : ""} ${
            mode === "light" ? "light-hamburger" : "dark-mode"
          }`}
          onClick={toggleTheme}
        >
          <span className="hamburger line1"></span>
          <span className="hamburger line2"></span>
          <span className="hamburger line3"></span>
        </div>

        <div
          className={`mobile_menu_dynamic ${navtheme ? "ham-menu-show" : ""}`}
        >
          <div className="mobile-menu-conatiner">
            <div className="d-flex flex-column flex-lg-row">
              <div
                className="custom-dropdown "
                onMouseEnter={() => window.innerWidth >= 991 && setAbout(true)}
                onMouseLeave={() => window.innerWidth >= 991 && setAbout(false)}
                onClick={(e) => {
                  if (window.innerWidth < 991) {
                    setAbout((prev) => !prev);
                    setService(false);
                    setIndustry(false);
                  }
                }}
              >
                <NavDropdown
                  title="Who We Are"
                  id="navbarScrollingDropdown"
                ></NavDropdown>
                <FiChevronDown
                  className={`chevron-icon d-block ${about ? "rotate" : ""}`}
                />
              </div>

              {about && window.innerWidth < 991 && (
                <div className="mobile-menu about">
                  {aboutMenu.map((it, index) => (
                    <Link key={index} to={it?.link}>
                      {it?.title}{" "}
                      <span className="ml-2">
                        <GoChevronRight fontSize={18} />
                      </span>
                    </Link>
                  ))}
                </div>
              )}

              <div
                className="custom-dropdown"
                onMouseEnter={() =>
                  window.innerWidth >= 991 && setService(true)
                }
                onMouseLeave={() =>
                  window.innerWidth >= 991 && setService(false)
                }
                onClick={(e) => {
                  if (window.innerWidth < 991) {
                    setService((prev) => !prev);
                    setAbout(false);
                    setIndustry(false);
                  }
                }}
              >
                <NavDropdown
                  title="What We Do"
                  id="navbarScrollingDropdown"
                ></NavDropdown>
                <FiChevronDown
                  className={`chevron-icon d-block ${service ? "rotate" : ""}`}
                />
              </div>

              {service && window.innerWidth < 991 && (
                <div className="mobile-menu">
                  {servicesMenu.map((it, index) => (
                    <Link key={index} to={it?.link}>
                      {it?.title}{" "}
                      <span className="ml-2">
                        <GoChevronRight fontSize={18} />
                      </span>
                    </Link>
                  ))}
                </div>
              )}

              <div
                className="custom-dropdown"
                onMouseEnter={() =>
                  window.innerWidth >= 991 && setIndustry(true)
                }
                onMouseLeave={() =>
                  window.innerWidth >= 991 && setIndustry(false)
                }
                onClick={(e) => {
                  if (window.innerWidth < 991) {
                    setIndustry((prev) => !prev);
                    setService(false);
                    setAbout(false);
                  }
                }}
              >
                <NavDropdown
                  title="Industries"
                  id="navbarScrollingDropdown"
                ></NavDropdown>
                <FiChevronDown
                  className={`chevron-icon d-block ${industry ? "rotate" : ""}`}
                />
              </div>

              {industry && window.innerWidth < 991 && (
                <div className="mobile-menu">
                  {industryMenu.map((it, index) => (
                    <Link key={index} to={it?.link}>
                      {it?.title}{" "}
                      <span className="ml-2">
                        <GoChevronRight fontSize={18} />
                      </span>
                    </Link>
                  ))}
                </div>
              )}

              <Link className="main-link" to="/career">
                Careers
              </Link>
              <CustomButton
                buttonText="Contact Us"
                buttonType="navBtn"
                arrow
                onClick={() => navigate("/contact")}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
